import React from 'react';
import { useMediaQuery } from '@mui/material';
const themeKey = 'theme';
async function getColorMode() {
    const value = localStorage.getItem(themeKey);
    return value && ['light', 'dark'].includes(value) ? value : null;
}
async function saveColorMode(mode) {
    return localStorage.setItem(themeKey, mode);
}
const ColorModeContext = React.createContext({
    toggleTheme: undefined,
    isThemeDark: false,
});
function ColorModeProvider({ children }) {
    const [isThemeDark, setIsThemeDark] = React.useState(false);
    const systemDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const toggleTheme = React.useCallback(() => {
        saveColorMode(isThemeDark ? 'light' : 'dark');
        setIsThemeDark((e) => !e);
    }, [isThemeDark]);
    React.useEffect(() => {
        (async () => {
            try {
                const mode = await getColorMode();
                if (mode) {
                    setIsThemeDark(mode === 'dark');
                }
                else {
                    saveColorMode(systemDarkMode ? 'dark' : 'light');
                    setIsThemeDark(systemDarkMode);
                }
            }
            catch (e) {
                console.error(e);
            }
        })();
    }, [systemDarkMode]);
    const provided = { toggleTheme, isThemeDark };
    return React.createElement(ColorModeContext.Provider, { value: provided }, children);
}
export { ColorModeContext, ColorModeProvider };
